"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountAuditEventTypeEnum = void 0;
var AccountAuditEventTypeEnum;
(function (AccountAuditEventTypeEnum) {
    AccountAuditEventTypeEnum[AccountAuditEventTypeEnum["Unspecified"] = 1] = "Unspecified";
    AccountAuditEventTypeEnum[AccountAuditEventTypeEnum["AccountReactivation"] = 2] = "AccountReactivation";
})(AccountAuditEventTypeEnum = exports.AccountAuditEventTypeEnum || (exports.AccountAuditEventTypeEnum = {}));
exports.default = AccountAuditEventTypeEnum;
